import { render, staticRenderFns } from "./DashboardMyInvitations.vue?vue&type=template&id=19e243c8&scoped=true"
import script from "./DashboardMyInvitations.vue?vue&type=script&lang=js"
export * from "./DashboardMyInvitations.vue?vue&type=script&lang=js"
import style0 from "./DashboardMyInvitations.vue?vue&type=style&index=0&id=19e243c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e243c8",
  null
  
)

export default component.exports